import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';
import cookie from 'vue-cookie'
var querystring = require('querystring');
const tokenAuthCrm = cookie.get('crm_auth_token');

Vue.use(Vuex)


export default new Vuex.Store({
    state: {
        // server state vars
        pageSetup: null,
        indexPromo: [],
        about: [],
        forms: null,
        flats: null,
        news: [],
        gallery: [],
        contacts: [],
        flatsCardsGlobal: [],
        flatsCardsGlobalDefault: [],
        // global data var
        isOpenFormModal: false,
        isOpenSendwich: false,
        isOpenFormLandModal: false,
         //  var for flat section
        flatCards: [],
        flatCardsDefault: [],
        cardAll: [],
        defaultCountCards: [],
        animateCards: true,

        // flats CRM VARS
        salesCardPage: null,
        salesCardContent: null,
        saleFilterParams: null,
        flatsItems: null,
        flatCard: null,
        flatsFilterData: null,
        pagin_PageNumber: 1,
        gridView: true,
        flatsEmptyMsg: false,
        objectDataCrm: null,
        visibleFilterMobile: false,
        FilterResetTrigger: false,
        modalData: null,
        // gCap_siteKey: '6LcgjM8pAAAAAB8Fx8_bPy5geZYi_YZxNNbDPoV0',
        gCap_siteKey: '6LfLWW4qAAAAAGLBMW6xaDx4_mXuuuP1htMzszrg',
        ucoCRM_oauth_token: null,
    },
    getters: {
        loadFormsData: state => state.forms,
        loadOpenFormModal: state => state.isOpenFormModal,
        loadOpenSendwich: state => state.isOpenSendwich,
        loadIsOpenFormLandModal: state => state.isOpenFormLandModal,
        loadIndexPromo: state => state.indexPromo,
        loadPageSetup: state => state.pageSetup,
        loadFormData: state => state.forms,
        //getters for flats CRM
        loadSalesCardPage: state => state.salesCardPage,
        loadSalesCardContent: state => state.salesCardContent,
        loadSalesFilterCardParams: state => state.saleFilterParams,
        loadFlatsPageData: state => state.flats,
        loadFlatsItems: state => state.flatsItems,
        loadFlatCard: state => state.flatCard,
        loadFlatsFilterData: state => state.flatsFilterData,
        loadPaginPageNumber: state => state.pagin_PageNumber,
        loadFlatsEmptyMsg: state => state.flatsEmptyMsg,
        loadObjectDataCrm: state => state.objectDataCrm,
        loadVisibleFilterMobile: state => state.visibleFilterMobile,
        loadLandFlatsGridView: state => state.gridView,
        loadSalesLandModalDataArr: state => state.modalData,
        loadResetTriggerMove: state => state.FilterResetTrigger,
        loadGcap_sitekey: state => state.gCap_siteKey,
        loadUcoCRM_auth_token: state => state.ucoCRM_oauth_token,
    },
    actions: {
        // server actions
        getPageSetUp({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'pages').then(async (response) => {
                // console.log(response.data[0].acf)
                commit('PageSetUp', response.data[0].acf)
            })
        },
        getSectionsData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'section').then(async (response) => {
                // console.log(response.data[3].acf)
                commit('IndexPromo', response.data[6].acf);
                commit('About', response.data[5].acf);
                commit('Flats', response.data[4].acf);
                commit('Gallery', response.data[3].acf);
                commit('News', response.data[1].acf);
                commit('Contacts', response.data[0].acf);
            });
        },
        getFormsData({commit}) {
            axios.get(window.url + window.GlobalLang + window.JsonUrl + 'forms').then(async (response) => {
                // console.log(response.data[0].acf)
                commit('Forms', response.data[0].acf);
            });
        },
         // action for flat section
        clearFlatCardAll({commit}, payload) {
            commit('cardAllClear', payload);
        },
        clearNewsData({commit}) {
            commit('newsDataClear');
        },

        // SALES CARD PROMO/LAND
        getSalesCardPageData({commit}) {
            axios.get(window.SalesURL + window.GlobalLang + window.JsonUrl + 'pages/1661').then(async (response) => {
                // console.log(response.data.acf, 'sale CARD PAGE DATA DEFAULT');
                commit('salesCardPage', response.data.acf);
            });
        },
        // FLATS FROM CRM
        // OAUTH 2.0 REST API CRM TEST
        getFlatsItems({commit, dispatch, state}, payload) { // FLATS DEFAULT LOAD
            if (this.state.flatsItems == null) {
                return new Promise((resolve, reject) => {
                    axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                        headers: { 
                            'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                        } 
                    }).then((response) => {
                        // console.log(response, response.data.data, 'apartments after AUTH');
                        commit('flatsItemsArr', response.data.data);
                        resolve('complete FLATS');
                    }).catch((error) => {
                        console.log('error getApartments default', error.response.data, error.response.status);
                    });
                });
            }
        },
        getFlatsByFilter({commit, dispatch, state}, payload) { // FLATS LOAD BY FILTER
            // console.log(payload)
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'FILTER APPS after AUTH');
                commit('flatsItemsArr', response.data.data);
            }).catch((error) => {
                console.log('error getApartments filter', error.response.data, error.response.status);
            });
        },
        getFlatsByPagination({commit, dispatch, state}, payload) { // FLATS LOAD BY pagination with filter and pagePaginNumber params
            // console.log(payload)
            axios.post(window.CRMurl + '/rest/prices/getApartments', payload, {
                headers: { 
                    'Authorization' :  `Bearer ${state.ucoCRM_oauth_token}`,
                } 
            }).then((response) => {
                // console.log(response, response.data.data, 'pagination after AUTH');
                commit('flatsItemsArrPagination', response.data.data);
            }).catch((error) => {
                console.log('error getApartments pagination', error.response.data, error.response.status);
            });
        },
        getCrmAuthToken({commit}, payload) { // Получение Токена из СРМ системы для oauth 2.0 в необходимых для авторизации запросов
            return new Promise((resolve, reject) => {
                axios.post('https://admin.sales.bazis.kz/server/new-auth.php', querystring.stringify({'secret_key' : '0L3QtSDRgdGD0LnRgtC1INGB0LLQvtC5INC90L7RgQ=='})).then((response) => {
                    if (response) {
                        var tokenParse = JSON.parse(response.data.token);
                        var token = tokenParse.access_token;
                        commit('setOauthToken_from_server', token);
                        resolve(true);
                        // console.log(token,'- token');
                    } else {
                        resolve(false);
                    }
                    // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
                }).catch((error) => {
                    console.log('error ' + error, 'erorr Get Token');
                    resolve(false);
                });
            });
        },
        // OBJECT HOUSE FROM CRM 
    },
    mutations: {
        setOauthToken_from_server(state, data) {
            state.ucoCRM_oauth_token = data;
        },
        // server mutations
        PageSetUp(state, setup) {
            state.pageSetup = setup
        },
        Forms(state, forms) {
            state.forms = forms
        },
        IndexPromo(state, indexPromo) {
            state.indexPromo = indexPromo
        },
        About(state, about) {
            state.about = about
        },
        Flats(state, flats) {
            state.flats = flats
        },
        Gallery(state, gallery) {
            state.gallery = gallery
        },
        News(state, news) {
            state.news = news
        },
        Contacts(state, contacts) {
            state.contacts = contacts
        },
        FlatsCardsGlobalArr(state, data) {
            var flatsArr = [];
            state.flatsCardsGlobal = [];
            state.flatsCardsGlobalDefault = [];
            for (var i = 0; i < data.length; i++) {
                flatsArr.push(Object.assign(data[i].acf, {
                    id: data[i].id,
                    slug: data[i].slug,
                }));
            }
            state.flatsCardsGlobal = flatsArr;
            state.flatsCardsGlobalDefault = flatsArr;
        },
        // global mutations for vars
        Open_Form_Modal(state, data) {
            state.isOpenFormModal = data
        },
        Open_Sendwich(state, data) {
            state.isOpenSendwich = data
        },
        // mutations for flat section
        cardAll(state, allcards) {
            state.cardAll.push(allcards);
        },
        cardAllClear(state, data) {
            state.flatsCardsGlobal = [];
            state.flatsCardsGlobal = data;
            // console.log(data, 'FLATS')
        },
        setCardAllToDefault(state, setDefault) {
            state.cardAll = [];
            state.cardAll = setDefault;
        },
        defaultCountCards(state, defaultCards) {
            state.defaultCountCards = defaultCards;
        },
        animateCards(state, data) {
            state.animateCards = data;
        },

        //////////// CRM BAZIS FLATS MUTATIONS
        salesCardPage(state, data) {
            state.salesCardPage = data;
        },
        salesCardContent(state, data) {
            state.salesCardContent = data;
        },
        FilterSaleItemCard_Set(state, data) {
            state.saleFilterParams = data
        },
        flatsItemsArr(state, data) {
            // console.log(data, 'test')
            state.flatsItems = data;
            if (data.length == 0) {
                state.flatsEmptyMsg = true
            } else {
                state.flatsEmptyMsg = false
            }
        },
        flatsItemsArrPagination(state, data) {
            // console.log(data, 'PAGINATION MUTATION');
            for (var i = 0; i < data.length; i++) {
                state.flatsItems.push(data[i]);
            }
            // console.log(state.flatsItems);
        },
        setObjectDataCRM(state, data) {
            state.objectDataCrm = data[0];
        },
        setFlatsFilterData(state, data) {
            state.flatsFilterData = data
        },
        UpdatePaginPageNumber(state, data) {
            state.pagin_PageNumber = data
        },
        // for flats
        SetVisibleFilterMobile(state, data) {
            state.visibleFilterMobile = data
        },
        TriggerResetFilterMove(state, data) {
            state.FilterResetTrigger = data
        },
        gridView(state, data) {
            state.gridView = data;
        },
        modalData(state, data) {
            state.modalData = data
        },
        Open_FormLandModal(state, data) {
            state.isOpenFormLandModal = data
        },
    }
})
